import { render } from "./AvailableYears.vue?vue&type=template&id=4910eaa8&scoped=true"
import script from "./AvailableYears.vue?vue&type=script&lang=js"
export * from "./AvailableYears.vue?vue&type=script&lang=js"

import "./AvailableYears.vue?vue&type=style&index=0&id=4910eaa8&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4910eaa8"]])

export default __exports__